module.exports = __webpack_public_path__ + "sms@2x.817c868f2c9b3a2eb00b7d82fdc16d5e.png";